var VendorPaymentAdapter = /** @class */ (function () {
    function VendorPaymentAdapter() {
    }
    VendorPaymentAdapter.prototype.initializeCreditCard = function (formRef, callbacks, cardFieldStyling, supportedCardBrands, onInitialized, existingCardHolder) {
        throw new Error();
    };
    VendorPaymentAdapter.prototype.remountCreditCardForm = function (locale) {
        throw new Error();
    };
    VendorPaymentAdapter.prototype.initializeGooglePay = function (formRef, googlePayConfiguration, buttonColor, callback, onProcessing, onAuthorized, isGooglePayAvailable) {
        throw new Error();
    };
    VendorPaymentAdapter.prototype.initializePayPal = function (formRef, paypalConfiguration, callback, onShopperDetails, isPayPalAvailable, locale) {
        throw new Error();
    };
    VendorPaymentAdapter.prototype.initializeThreeDS = function (tokenizationResult, threeDSActionContainer, threeDSConfiguration) {
        throw new Error();
    };
    VendorPaymentAdapter.prototype.submitPaymentForm = function (config, paymentInformation, threedsActionContainer, setErrorDetails, actionCallback, onPaymentSuccess, onPaymentFailure) {
        throw new Error();
    };
    return VendorPaymentAdapter;
}());
export { VendorPaymentAdapter };
